export default __webpack_public_path__ + "static/media/logo.fb330ed9.png";